import React from "react";
import { Flex, Typography } from "orcs-design-system";

const tourOptions = () => ({
  triggerInSidebar: false,
  autoStart: true,
  showProgress: false,
  showSkipButton: false,
  hideBackButton: true,
  hideFooter: true,
  steps: [
    {
      target: ".guided-tour-sidebar-icon",
      hideFooter: true,
      content: (
        <Flex flexDirection="column" gap="s">
          <Typography.P weight="bold" textAlign="center">
            Hi there, did you know there is a guided tour for this page?
          </Typography.P>
          <Typography.Small textAlign="center">
            Click this icon to get started!
          </Typography.Small>
        </Flex>
      ),
    },
  ],
});

export default tourOptions;
